/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Admin_Role_RequiredInputs */

const en_api_error_admin_role_required = /** @type {(inputs: Api_Error_Admin_Role_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrator role is required.`)
};

const pt_br2_api_error_admin_role_required = /** @type {(inputs: Api_Error_Admin_Role_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Função de administrador é necessária.`)
};

/**
* | output |
* | --- |
* | "Administrator role is required." |
*
* @param {Api_Error_Admin_Role_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_admin_role_required = /** @type {((inputs?: Api_Error_Admin_Role_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Admin_Role_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_admin_role_required(inputs)
	return pt_br2_api_error_admin_role_required(inputs)
});